export function getEmailData() {

    const email_password_rossi = window.localStorage.getItem('marc.novak')

    /* eslint-disable */
    let data = {
        emails : [
            // novak-gussmann mails
            {
                id: 1,
                from: {
                    email: 'rambo15@pronto-posto.com',
                    name: 'Unbekannt',
                    avatar: require('@src/assets/images/portrait/gussmann.jpg').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }],
                subject: 'Versteck',
                cc: [],
                bcc: [],
                message: '<p>Ich hab die Beute wie besprochen vergraben.</p><p>Schau mal im Anhang.</p>',
                attachments: [
                    {
                        fileName: 'tattoo_entwurf.jpg',
                        thumbnail: require('@src/assets/images/icons/jpg.png').default,
                        url: 'https://storage.googleapis.com/cc-pronto-posto/ks02_tattoo_entwurf.jpg',
                        size: '273kb',
                        password: 'johnsdiner'
                    },
                ],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Apr. 07 2022 07:45:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: true
            },
            {
                id: 3,
                from: {
                    email: 'rambo15@pronto-posto.com',
                    name: 'Unbekannt',
                    avatar: require('@src/assets/images/portrait/gussmann.jpg').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }],
                subject: 'RE: Versteck',
                cc: [],
                bcc: [],
                message: 'Junge das hatten wir doch besprochen! Hinweis: Dein Lieblingsort.',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Apr. 07 2022 09:03:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 2,
                        from: {
                            email: 'marc.novak@pronto-posto.com',
                            name: 'Marc Novak',
                            avatar: require('@src/assets/images/portrait/novak.jpg').default
                        },
                        to: [{
                            name: 'Unbekannt',
                            email: 'rambo15@pronto-posto.com'
                        }],
                        subject: 'RE: Versteck',
                        cc: [],
                        bcc: [],
                        message: 'Sehr gut. Aber das ist passwortgeschützt ich kann es nicht öffnen!!',
                        attachments: [],
                        isStarred: false,
                        labels: ['personal'],
                        time: 'Do. Apr. 07 2022 09:56:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'sent',
                        isRead: true
                    },
                ],
                folder: 'inbox',
                isRead: true
            },
            {
                id: 4,
                from: {
                    email: 'rambo15@pronto-posto.com',
                    name: 'Unbekannt',
                    avatar: require('@src/assets/images/portrait/gussmann.jpg').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }],
                subject: 'Probleme',
                cc: [],
                bcc: [],
                message: 'Mist wir sind kurz vorm auffliegen!! Habe in der Zeitung gelesen, dass jemand deine Stimme erkannt hat',
                attachments: [],
                isStarred: true,
                labels: ['personal'],
                time: 'Fr. Apr. 08 2022 12:23:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 7,
                        from: {
                            email: 'marc.novak@pronto-posto.com',
                            name: 'Marc Novak',
                            avatar: require('@src/assets/images/portrait/novak.jpg').default
                        },
                        to: [{
                            name: 'Unbekannt',
                            email: 'rambo15@pronto-posto.com'
                        }],
                        subject: 'RE: Probleme',
                        cc: [],
                        bcc: [],
                        message: 'Ganz ruhig. Habe jetzt auch den Artikel gelesen. Ist alles halb so wild. Der weiß ja garnicht wer ich bin',
                        attachments: [],
                        isStarred: false,
                        labels: ['personal'],
                        time: 'Fr. Apr. 08 2022 15:48:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'sent',
                        isRead: true
                    },
                    {
                        id: 6,
                        from: {
                            email: 'rambo15@pronto-posto.com',
                            name: 'Unbekannt',
                            avatar: require('@src/assets/images/portrait/gussmann.jpg').default
                        },
                        to: [{
                            name: 'Marc Novak',
                            email: 'marc.novak@pronto-posto.com'
                        }],
                        subject: 'RE: RE: RE: RE: Versteck',
                        cc: [],
                        bcc: [],
                        message: 'Plan B, Ich tauch erstmal unter! Lassen wir ein bisschen Gras über die Sache wachsen. Schön Zuhause bleiben und nicht auffallen! Hoffentlich reicht das... ich werd nervös bei sowas',
                        attachments: [],
                        isStarred: false,
                        labels: ['personal'],
                        time: 'Fr. Apr. 08 2022 15:06:00 GMT+0000 (GMT)',
                        replies: [
                            {
                                id: 5,
                                from: {
                                    email: 'marc.novak@pronto-posto.com',
                                    name: 'Marc Novak',
                                    avatar: require('@src/assets/images/portrait/novak.jpg').default
                                },
                                to: [{
                                    name: 'Unbekannt',
                                    email: 'rambo15@pronto-posto.com'
                                }],
                                subject: 'RE: RE: RE: Versteck',
                                cc: [],
                                bcc: [],
                                message: 'Scheibenkleister! Was machen wir jetzt?',
                                attachments: [],
                                isStarred: false,
                                labels: ['personal'],
                                time: 'Fr. Apr. 08 2022 14:16:00 GMT+0000 (GMT)',
                                replies: [],
                                folder: 'inbox',
                                isRead: true
                            },
                        ],
                        folder: 'inbox',
                        isRead: true
                    },
                ],
                folder: 'inbox',
                isRead: true
            },
            {
                id: 9,
                from: {
                    email: 'rambo15@pronto-posto.com',
                    name: 'Unbekannt',
                    avatar: require('@src/assets/images/portrait/gussmann.jpg').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }],
                subject: 'RE: Telefonieren',
                cc: [],
                bcc: [],
                message: '<p>Okay.</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Apr. 14 2022 13:22:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 8,
                        from: {
                            email: 'marc.novak@pronto-posto.com',
                            name: 'Marc Novak',
                            avatar: require('@src/assets/images/portrait/novak.jpg').default
                        },
                        to: [{
                            name: 'Unbekannt',
                            email: 'rambo15@pronto-posto.com'
                        }],
                        subject: 'RE: RE: RE: RE: RE: RE: Versteck',
                        cc: [],
                        bcc: [],
                        message: 'Lass uns kurz telefonieren... es haben sich ein paar Komplikationen ergeben! Aber versprich mir dass du nichts dummes machst!',
                        attachments: [],
                        isStarred: false,
                        labels: ['personal'],
                        time: 'Do. Apr. 14 2022 13:22:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'inbox',
                        isRead: true
                    }
                ],
                folder: 'inbox',
                isRead: true
            },
            // rossi-novak mails
            {
                id: 11,
                from: {
                    email: 'marc.novak@pronto-posto.com',
                    name: 'Marc Novak',
                    avatar: require('@src/assets/images/portrait/novak.jpg').default
                },
                to: [{
                    name: 'Francesca Rossi',
                    email: 'francesca.amore@pronto-posto.com'
                }],
                subject: 'RE: :*',
                cc: [],
                bcc: [],
                message: '<p>Ja ja. Irgendwann kommt unsere Beziehung doch sowieso raus. Aber das ist egal.</p><p>Ich liebe dich ' + email_password_rossi + ' mal :*</p>',
                attachments: [],
                isStarred: true,
                labels: ['personal'],
                time: 'Sa. Apr. 02 2022 18:19:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 10,
                        from: {
                            name: 'Francesca Rossi',
                            email: 'francesca.amore@pronto-posto.com',
                            avatar: require('@src/assets/images/portrait/rossi.jpg').default
                        },
                        to: [{
                            email: 'marc.novak@pronto-posto.com',
                            name: 'Marc Novak',
                        }],
                        subject: ':*',
                        cc: [],
                        bcc: [],
                        message: 'Wir müssen mehr aufpassen! Gestern hätte uns fast dieser Reporter von News Flash erwischt.',
                        attachments: [],
                        isStarred: true,
                        labels: ['personal'],
                        time: 'Sa. Apr. 02 2022 18:19:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'inbox',
                        isRead: true
                    },
                ],
                folder: 'inbox',
                isRead: true
            },
            {
                id: 13,
                from: {
                    email: 'marc.novak@pronto-posto.com',
                    name: 'Marc Novak',
                    avatar: require('@src/assets/images/portrait/novak.jpg').default
                },
                to: [{
                    name: 'Francesca Rossi',
                    email: 'francesca.amore@pronto-posto.com'
                }],
                subject: 'RE: RE: :*',
                cc: [],
                bcc: [],
                message: 'Ist ja auch meine Lieblingszahl. Die bringt mir Glück!',
                attachments: [],
                isStarred: true,
                labels: ['personal'],
                time: 'Sa. Apr. 02 2022 18:55:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 12,
                        from: {
                            email: 'francesca.amore@pronto-posto.com',
                            name: 'Francesca Rossi',
                            avatar: require('@src/assets/images/portrait/rossi.jpg').default
                        },
                        to: [{
                            name: 'Marc Novak',
                            email: 'marc.novak@pronto-posto.com'
                        }],
                        subject: 'RE: RE: :*',
                        cc: [],
                        bcc: [],
                        message: 'Das ist aber ganz schön oft :D',
                        attachments: [],
                        isStarred: false,
                        labels: ['personal'],
                        time: 'Sa. Apr. 02 2022 18:36:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'sent',
                        isRead: true
                    },
                ],
                folder: 'inbox',
                isRead: true
            },
            {
                id: 14,
                from: {
                    email: 'noreply@filebox.posto-pronto.com',
                    name: 'Filebox',
                    avatar: require('@src/assets/images/portrait/filebox.jpeg').default
                },
                to: [{
                    name: 'Francesca Rossi',
                    email: 'francesca.amore@pronto-posto.com'
                }],
                subject: 'Ein Ordner wurde mit Ihnen geteilt',
                cc: [],
                bcc: [],
                message: '<p>J. Seeholz hat den Ordner filebox/Rossi/RosesofSadness/ mit Ihnen geteilt.</p><p>Klicken sie hier um zum Ordner zu gelangen: <a href="https://filebox.pronto-posto.com/seeholz-music-backup-server/" target="_blank">https://filebox.pronto-posto.com/seeholz-music-backup-server/</a></p><p>Ihr Filebox Team</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Sa. Apr. 16 2022 16:34:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: true
            },







            // KS03 Traumschiff Rework: Petra - Rafaela Mails


            {
                id: 15,
                from: {
                    email: 'p.witzgold@pronto-posto.com',
                    name: 'Petra W',
                    avatar: require('@src/assets/images/portrait/petra.png').default
                },
                to: [{
                    name: 'Rafaela S',
                    email: 'raf.silva@pronto-posto.com'
                }],
                subject: 'St. Helen – neue Story?',
                cc: [],
                bcc: [],
                message: 'Hey Rafaela,<p>ich habe auf der Arbeit gehört, dass dein Verlobter Tickets für die <b>St. Helen</b> gewonnen hat.<br><br>Erinnerst du dich noch an den Bericht über Helmstadt, an dem ich vor kurzem gearbeitet hatte?<br>Guck dir den nochmal an... Du wirst es nicht glauben, aber bei meiner damaligen Recherche bin ich auch auf den Namen <b>Jürgen Hoffmann</b> gestoßen.<br><br>Und weißt du, wer das ist? <b>DER Kapitän der St. Helen.</b><br><br>Schau dir mal die <b>HS-Nautik</b> an. Das ist die Hochschule, an der der Kapitän sein Studium absolviert haben will...<br><br>Ich will dir ja nicht vorschreiben, während deines Urlaubs zu arbeiten, aber DAS wäre schon ein glorreicher Bericht.<br><br>Gerne helfe ich dir auch, soweit ich kann, aber bitte sei vorsichtig, wo und wie du deine Recherche dokumentierst. Solche Menschen sind stets auf der Hut und gut vernetzt.<br><br>Liebe Grüße und bis morgen,<br>Petra',
                attachments: [],
                isStarred: true,
                labels: ['work'],
                time: 'Tue. Jan. 31 2023 15:43:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: true
            },

            {
                id: 16,
                from: {
                    email: 'p.witzgold@pronto-posto.com',
                    name: 'Petra W',
                    avatar: require('@src/assets/images/portrait/petra.png').default
                },
                to: [{
                    name: 'Rafaela S',
                    email: 'raf.silva@pronto-posto.com'
                }],
                subject: 'Re: Klabautermann?',
                cc: [],
                bcc: [],
                message: 'Hey Rafaela,<p>also das mit dem <b>Klabautermann</b> klingt eher nach Klatschpresse. Wir können doch keine Geistergeschichten veröffentlichen!<br><br>Hast du nicht vielleicht irgendwas zum Kapitän oder der Crew?',
                attachments: [],
                isStarred: false,
                labels: ['work'],
                time: 'Mon. Mar. 06 2023 10:35:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 17,
                        from: {
                            email: 'raf.silva@pronto-posto.com',
                            name: 'Rafaela S',
                            avatar: require('@src/assets/images/portrait/rafaela.png').default
                        },
                        to: [{
                            name: 'Petra W',
                            email: 'p.witzgold@pronto-posto.com'
                        }],
                        subject: 'Klabautermann?',
                        cc: [],
                        bcc: [],
                        message: 'Hallo Petra,<p>ich habe natürlich mein Notizbuch mitgenommen. Die wichtigsten Informationen bewahre ich – ganz altmodisch – darin auf. Das habe ich eigentlich immer bei mir, also mach dir keine Sorgen. Da kommt so schnell keiner dran ;) <br><br>Aber du hattest recht, irgendetwas auf diesem Schiff ist merkwürdig. Ich habe mir ein paar Notizen gemacht:<br><br><b>Klabautermann?</b><br>- Petra meint, ich soll nicht darüber schreiben, aber ich glaube, da steckt mehr dahinter.<br>- Tobias sagt: Der Geist wohnt neben ihm im Zimmer. Eine Frau mit dunklen Haaren steht immer im Flur und starrt das Zimmer an, verschwindet aber, sobald jemand kommt. → Als ich sie angesprochen habe, ist sie mir ausgewichen. Wer ist sie? Vielleicht weiß sie etwas. <br>- Träumt Tobias nur? Ich weiß nicht, ob ich daran glauben soll.<br><br><i>Danke, dass du dir Sorgen machst, Petra :)</i>',                        attachments: [],
                        isStarred: false,
                        labels: ['work'],
                        time: 'Sun. Mar. 05 2023 20:24:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'sent',
                        isRead: true
                    }
                ],
                folder: 'inbox',
                isRead: true
            },

            {
                id: 18,
                from: {
                    email: 'p.witzgold@pronto-posto.com',
                    name: 'Petra W',
                    avatar: require('@src/assets/images/portrait/petra.png').default
                },
                to: [{
                    name: 'Rafaela S',
                    email: 'raf.silva@pronto-posto.com'
                }],
                subject: 'Re: Weitere Notizen',
                cc: [],
                bcc: [],
                message: 'Rafaela, bitte sei vorsichtig! Lass es lieber sein, wenn es zu gefährlich wird!',
                attachments: [],
                isStarred: false,
                labels: ['work'],
                time: 'Thu. Mar. 09 2023 08:12:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 19,
                        from: {
                            email: 'raf.silva@pronto-posto.com',
                            name: 'Rafaela S',
                            avatar: require('@src/assets/images/portrait/rafaela.png').default
                        },
                        to: [{
                            name: 'Petra W',
                            email: 'p.witzgold@pronto-posto.com'
                        }],
                        subject: 'Weitere Notizen',
                        cc: [],
                        bcc: [],
                        message: 'Hallo Petra,<p>ja... da hast du vermutlich recht. Die Crew verhält sich ebenfalls sonderbar. Ich habe noch nichts Handfestes, aber mir sind ein paar Sachen aufgefallen:<br><br><b>Der Kapitän</b><br>- Interview 08.03, sehr unfreundlich, weicht meinen Fragen aus.<br>- www.hs-nautik.de<br>- Crew verliert kein negatives Wort über ihn, und er nimmt sie in Schutz – alle stecken unter einem Hut (?!)<br>- Bin beim Interview an seine Karte rangekommen. Die 01 sollte auf alle Kabinen Zugriff haben. Ich brauche sie nur kurz, dann lass ich sie wieder auftauchen. Er wird davon nichts mitbekommen.<br><br><b>Sonstiges</b><br>- Ich habe das Gefühl, immer irgendwen zu sehen, wenn ich mein Zimmer verlasse... werde ich verfolgt?<br>- Romy und Axel scheinen ein Paar zu sein<br>- Tobias meint, dass keiner ihm wegen der Lärmbelästigung im Zimmer neben ihm helfen will<br>- Axel und Romy verlangen Geld für ein Interview → bestechlich??<br>- Wollte schauen, was es mit dieser Frau auf sich hat und habe etwas Schlimmes entdeckt. Ich muss erstmal untertauchen, das wird zu gefährlich...<br><br>Es gibt auch noch ein paar andere Sachen, aber die schreibe ich lieber nur analog auf.',
                        attachments: [],
                        isStarred: false,
                        labels: ['work'],
                        time: 'Wed. Mar. 08 2023 21:03:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'sent',
                        isRead: true
                    }
                ],
                folder: 'inbox',
                isRead: true
            },








            // luna–lange mails (ks04 flug)


            {
                id: 21,
                from: {
                    email: 'lady.luna@seelenraum-tv.de',
                    name: 'Lady Luna',
                    avatar: require('@src/assets/images/portrait/luna.jpg').default
                },
                to: [{
                    name: 'Max Lange',
                    email: 'm.lange@pronto-posto.com'
                }],
                subject: 'Re: Anfrage: Sonder-Seance in Ihrer Sendung',
                cc: [],
                bcc: [],
                message: 'Max,<p>das Thema scheint ja sehr wichtig für Sie zu sein. Damit wir ganz sicher gehen, dass die Karten sich nicht doch unerwartet anders entscheiden oder ich mich in der Show verplappere, müssten es schon 6000€ Honorar sein.<p>Gruß<p> Lady Luna',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Thu. Mar. 28 2024 15:08:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 20,
                        from: {
                            email: 'm.lange@pronto-posto.com',
                            name: 'Max Lange',
                            avatar: require('@src/assets/images/portrait/lange.jpg').default
                        },
                        to: [{
                            name: 'Lady Luna',
                            email: 'lady.luna@seelenraum-tv.de'
                        }],
                        subject: 'Anfrage: Sonder-Seance in Ihrer Sendung',
                        cc: [],
                        bcc: [],
                        message: 'Hallo Lady Luna,<p>wenn ich Sie richtig einschätze, sind wir quasi Berufskollegen, und Sie sind einem kleinen Zusatzverdienst nie abgeneigt.<p>Ich hätte da einen Spezialauftrag: Meine abergläubische Schwiegermutter Krystyna Zielinski wird vermutlich am 31.03. bei Ihnen zum 10 Jahres Jubiläum von Ihrem Sender durchklingeln. Sie ist einer Ihrer Stamm-Zuseher. Sie muss unter allen Umständen davon überzeugt werden, ihre Landvilla an ihre Tochter (und mich) zu überschreiben. Bitte sorgen Sie in der Sendung dafür, dass die Karten klar zur Schenkung raten – egal, was sie wirklich sagen.<p>Ich biete 3000€ Honorar. Diskretion setze ich voraus.<p><p>Gruß<p>Max Lange',
                        attachments: [],
                        isStarred: false,
                        labels: ['personal'],
                        time: 'Thu. Mar. 28 2024 14:02:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'sent',
                        isRead: true
                    }
                ],
                folder: 'inbox',
                isRead: true
            },

            {
                id: 23,
                from: {
                    email: 'lady.luna@seelenraum-tv.de',
                    name: 'Lady Luna',
                    avatar: require('@src/assets/images/portrait/luna.jpg').default
                },
                to: [{
                    name: 'Max Lange',
                    email: 'm.lange@pronto-posto.com'
                }],
                subject: 'Re: Re: Re: Anfrage: Sonder-Seance in Ihrer Sendung',
                cc: [],
                bcc: [],
                message: 'Geld ist eingegangen. Ich richte die Karten wie gewünscht aus – Ihre Schwiegermutter bekommt das perfekte Zeichen zur Schenkung.<p>Ich lasse Ihnen einen Best-Of Clip zukommen, sobald die Show im Kasten ist.<p>Auf weitere gute Geschäfte<p>Lady Luna',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Thu. Mar. 28 2024 21:58:00 GMT+0000 (GMT)',
                replies: [
                    {
                        id: 22,
                        from: {
                            email: 'm.lange@pronto-posto.com',
                            name: 'Max Lange',
                            avatar: require('@src/assets/images/portrait/lange.jpg').default
                        },
                        to: [{
                            name: 'Lady Luna',
                            email: 'lady.luna@seelenraum-tv.de'
                        }],
                        subject: 'Re: Re: Anfrage: Sonder-Seance in Ihrer Sendung',
                        cc: [],
                        bcc: [],
                        message: 'Soll das eine Erpressung werden???? Frechheit. Aber okay, ich bin heute in guter Laune. 5000€ aber keinen Cent mehr. Am besten in Krypto. Lassen Sie uns nachher mal telefonieren. +49 XXXXX152.',
                        attachments: [],
                        isStarred: false,
                        labels: ['personal'],
                        time: 'Thu. Mar. 28 2024 18:22:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'sent',
                        isRead: true
                    }
                ],
                folder: 'inbox',
                isRead: true
            },

            {
                id: 24,
                from: {
                    email: 'lady.luna@seelenraum-tv.de',
                    name: 'Lady Luna',
                    avatar: require('@src/assets/images/portrait/luna.jpg').default
                },
                to: [{
                    name: 'Max Lange',
                    email: 'm.lange@pronto-posto.com'
                }],
                subject: 'Die Karten haben gesprochen',
                cc: [],
                bcc: [],
                message: 'Max,<p>Die Karten haben gesprochen. Im Anhang ist der Clip bezüglich unseres kleinen Arrangements.<p>Auf weitere gute Geschäfte<p>Lady Luna<p>PS: Falls Sie öfter Hilfe brauchen: Bei SeelenraumTV gibt’s für jedes Anliegen eine Lösung, solange das Universum (und Ihr Konto) mitspielt.',
                attachments: [
                    {
                        fileName: 'clip_seelenraum_tv.mp4',
                        thumbnail: require('@src/assets/images/icons/jpg.png').default,
                        url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_seelenraum_clip.mp4',
                        size: '10mb',
                    },
                ],
                isStarred: true,
                labels: ['personal'],
                time: 'So. Mar. 31 2024 15:45:00 GMT+0000 (GMT)',

                replies: [
                    {
                        id: 25,
                        from: {
                            email: 'm.lange@pronto-posto.com',
                            name: 'Max Lange',
                            avatar: require('@src/assets/images/portrait/lange.jpg').default
                        },
                        to: [{
                            name: 'Lady Luna',
                            email: 'lady.luna@seelenraum-tv.de'
                        }],
                        subject: 'Re: Die Karten haben gesprochen',
                        cc: [],
                        bcc: [],
                        message: 'Hab eben den Best-Of Clip angeschaut, man was für Spinner hahaha, dachte sowas gibt’s nur in der Krypto Bubble. Aber egal, Krystyna hat den Köder geschluckt. <p>Danke für die „göttliche“ Unterstützung.<p>Melde mich wieder, falls Bedarf!',
                        attachments: [],
                        isStarred: false,
                        labels: ['personal'],
                        time: 'So. Mar. 31 2024 18:40:00 GMT+0000 (GMT)',
                        replies: [],
                        folder: 'sent',
                        isRead: true
                    },
                ],
                folder: 'inbox',
                isRead: true
            },
            {
                id: 26,
                from: {
                    email: 'renderrambo@pronto-posto.com',
                    name: 'Render Rambo',
                    avatar: require('@src/assets/images/portrait/rambo.jpg').default
                },
                to: [{
                    name: 'Max Lange',
                    email: 'm.lange@pronto-posto.com'
                }],
                subject: 'Neues Reel',
                cc: [],
                bcc: [],
                message: 'Hey Maxx,<p>Hab dein Reel fertig gecuttet, richtig fresh geworden! Die Finanzbros werden es lieben, schick mir doch die Bezahlung gleich als BillionCoins, mich hast du total überzeugt :P<p>Lass mich auf jeden Fall wissen, ob dir das Video taugt, so wie es ist, oder ob ich noch was dran ändern soll.<p>Video ist im Anhang<p>P.S: Lad mich dann mal auf deinen neuen Schlitten ein ;)',
                attachments: [
                    {
                        fileName: 'CryptoReel_Maxx.mp4',
                        thumbnail: require('@src/assets/images/icons/mp4.png').default,
                        url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_cryptoreel_maxx.mp4',
                        size: '10mb',
                    },
                ],
                isStarred: false,
                labels: ['work'],
                time: 'So. Feb. 25 2024 16:45:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: true
            },





        ]
    }
    return data
}
